import { render, staticRenderFns } from "./TournamentCard.vue?vue&type=template&id=e7a33d5e&scoped=true"
import script from "./TournamentCard.vue?vue&type=script&lang=js"
export * from "./TournamentCard.vue?vue&type=script&lang=js"
import style0 from "./TournamentCard.vue?vue&type=style&index=0&id=e7a33d5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a33d5e",
  null
  
)

export default component.exports